// The Actionstep matter folders the portal files documents into.
//
// THESE NAMES ARE FIRM-SPECIFIC. This is the folder structure used by the firm the portal
// is first being fitted to. Another firm will organise its matters differently, so this is
// one small module rather than names written inline across pages: when per-firm
// configuration exists, there is a single place to move.
//
// It is not that yet. The portal has no per-tenant settings store, and the same unresolved
// question sits behind the mail provider work (see docs/EMAIL_PROVIDER.md): who the firm
// is, and where their settings live, is unanswered across the product rather than only
// here. Environment overrides make a second firm possible without a code change, which is
// enough while one firm is being fitted and honest about not being enough after that.
//
// A folder that does not exist in the matter is not an error: the document is filed at the
// matter root instead. Losing a document because a folder was renamed would be a far worse
// outcome than filing it in the wrong place.

const fromEnv = (name, fallback) => {
  const value = import.meta.env?.[name];
  return typeof value === "string" && value.trim() ? value.trim() : fallback;
};

export const ACTIONSTEP_FOLDERS = {
  vlaFunding: fromEnv("VITE_ACTIONSTEP_FOLDER_VLA_FUNDING", "VLA Funding docs"),
  supportMaterials: fromEnv("VITE_ACTIONSTEP_FOLDER_SUPPORT", "Support materials"),
  fileNotes: fromEnv("VITE_ACTIONSTEP_FOLDER_FILE_NOTES", "File Notes"),
  courtDocuments: fromEnv("VITE_ACTIONSTEP_FOLDER_COURT", "Court Documents"),
  correspondenceOther: fromEnv("VITE_ACTIONSTEP_FOLDER_CORRESPONDENCE_OTHER", "Correspondence - other"),
  correspondenceClient: fromEnv("VITE_ACTIONSTEP_FOLDER_CORRESPONDENCE_CLIENT", "Correspondence - client"),
  boeAndDisclosure: fromEnv("VITE_ACTIONSTEP_FOLDER_BOE", "BOE and disclosure"),
};

// What each kind of portal document is, and therefore where it belongs. Keyed by the
// document rather than by the page, because the same page can produce several kinds - the
// certification sheet and the brief of evidence are saved together and file separately.
export const ACTIONSTEP_DOCUMENT_FOLDERS = {
  certification: ACTIONSTEP_FOLDERS.vlaFunding,
  aidApplication: ACTIONSTEP_FOLDERS.vlaFunding,
  briefOfEvidence: ACTIONSTEP_FOLDERS.boeAndDisclosure,
  courtDocument: ACTIONSTEP_FOLDERS.courtDocuments,
  clientCorrespondence: ACTIONSTEP_FOLDERS.correspondenceClient,
  otherCorrespondence: ACTIONSTEP_FOLDERS.correspondenceOther,
  supportMaterial: ACTIONSTEP_FOLDERS.supportMaterials,
  fileNote: ACTIONSTEP_FOLDERS.fileNotes,
};

export function actionstepFolderFor(kind) {
  return ACTIONSTEP_DOCUMENT_FOLDERS[kind] || "";
}
